module.exports = __webpack_public_path__ + "img/hoheykyo.4167113d.png";